export const IS_LOGGED_IN = "IS_LOGGED_IN";
export const USER_PROFILE = "USER_PROFILE";
export const USER_COMPANY = "USER_COMPANY";
export const USER_SUBSCRIPTION = "USER_SUBSCRIPTION";
export const USER_ROLE = "USER_ROLE";
export const RESET_USER = "RESET_USER";
export const IS_PROFILE_CHANGED = "IS_PROFILE_CHANGED";
export const IS_SUBSCRIPTION_CHANGE = "IS_SUBSCRIPTION_CHANGE";
export const USER_ASSETS = "USER_ASSETS";
export const IS_ASSETS_CHANGED = "IS_ASSETS_CHANGED";